const notificationEnum = Object.freeze({
  CHECK_IMAGER_SYNC: {
    STEP: {
      success: 'Camera date/time match confirmed!',
      pending: 'Confirm camera and device are set to the same date and time:',
    },
    BUTTON: {
      confirm: 'Confirm date/time match',
      hideRemaining: 'and hide for remaining items',
    },
  },
});

export default notificationEnum;
